// Add Card

export const GET_CUSTOMER_CHATS_REQUEST = 'GET_CUSTOMER_CHATS_REQUEST';
export const GET_CUSTOMER_CHATS_SUCCESS = 'GET_CUSTOMER_CHATS_SUCCESS';
export const GET_CUSTOMER_CHATS_FAILURE = 'GET_CUSTOMER_CHATS_FAILURE';

export const DELETE_CHAT_REQUEST = 'DELETE_CHAT_REQUEST';
export const DELETE_CHAT_SUCCESS = 'DELETE_CHAT_SUCCESS';
export const DELETE_CHAT_FAILURE = 'DELETE_CHAT_FAILURE';

export const GET_UNREAD_COUNT_REQUEST = 'GET_UNREAD_COUNT_REQUEST';
export const GET_UNREAD_COUNT_SUCCESS = 'GET_UNREAD_COUNT_SUCCESS';
export const GET_UNREAD_COUNT_FAILURE = 'GET_UNREAD_COUNT_FAILURE';

export const SEND_NEW_MESSAGE_REQUEST = 'SEND_NEW_MESSAGE_REQUEST';
export const SEND_NEW_MESSAGE_SUCCESS = 'SEND_NEW_MESSAGE_SUCCESS';
export const SEND_NEW_MESSAGE_FAILURE = 'SEND_NEW_MESSAGE_FAILURE';

export const UPDATE_CUSTOMER_CHAT_PINNED = 'UPDATE_CUSTOMER_CHAT_PINNED';
export const UPDATE_CUSTOMER_CHAT_CLEAR_CONVERSION =
  'UPDATE_CUSTOMER_CHAT_CLEAR_CONVERSION';

export const UPDATE_CHAT_DELETED_KEY = 'UPDATE_CHAT_DELETED_KEY';

export const MINUS_UNREAD_COUNT = 'MINUS_UNREAD_COUNT';
export const PLUS_UNREAD_COUNT = 'PLUS_UNREAD_COUNT';

export const SELECTED_CUSTOMER_CHAT = 'SELECTED_CUSTOMER_CHAT';

export const CLEAR_NEW_MESSAGE = 'CLEAR_NEW_MESSAGE';
